// extracted by mini-css-extract-plugin
module.exports = {"anchorLink":"AnygiftAnchorLink_anchorLink__B9B7j","anchorArrow":"AnygiftAnchorLink_anchorArrow__Gd0Gq"};